export const EC_UPSELL = 'ec-upsell'
export const EC_CHECK_CTA = 'ec-check-CTA'
export const EC_UPSELL_ITEM = 'ec-upsell-item'
export const EC_UPSELL_HEADING = 'ec-upsell-heading'

export const GP_UPSELL = 'gp-upsell'
export const GP_CTA = 'gp-CTA'
export const GP_UPSELL_ITEM = 'gp-upsell-item'

export const TC_LINK = 'tc-link'

export const CITATION_UPSELL = 'citation-upsell'
export const CITATION_CTA = 'citation-check-CTA'
export const CITATION_UPSELL_ITEM = 'citation-upsell-item'
export const CITATION_UPSELL_HEADING = 'citation-upsell-heading'
export const CITATION_UPSELL_SUB_HEADING = 'citation-upsell-sub-heading'
